import React, { Component } from 'react';
import './contact.css';

class Contact extends Component {
  render() {
    return (
      <div className="contact">
        <div>
          <h2>Get In Touch</h2>
        </div>
        <p>
          You can write to me on <a href="https://facebook.com/solo.arni" target="_blank">Facebook</a>,
          connect through <a href="http://www.linkedin.com/in/lukaszsoluch" target="_blank">LinkedIn</a> or
          see what I'm doing by following <a href="https://twitter.com/lukaszsoluch" target="_blank">@lukaszsoluch</a>
        </p>
      </div>
    );
  }
}

export default Contact;



/** WEBPACK FOOTER **
 ** ./src/contact/contact.js
 **/